import {styled} from '../../styled-components';

/**
 * Container component for Dialog title at the top of the dialog.
 */
export const DialogTitleStyle = styled.div`
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    height: ${props => props.theme.spacing.units(12)};
    padding: ${props => props.theme.spacing.units(0, 4)};
    background: ${props => props.theme.color.primary.main};
    color: ${props => props.theme.color.text};
    font-size: ${props => props.theme.typography.pxToRem(20)};
    text-transform: uppercase;
    font-family: ${props => props.theme.typography.fontFamily};
`;

DialogTitleStyle.displayName = 'DialogTitleStyle';
